angular.module("practicesGroup.components", []).component("practicesGroup", {
    templateUrl: "ng/components/riskCourse/practicesGroup/practicesGroup.view.html",
    bindings: {
        model: "=",
        preventiviAccettati: "=",
        importoPreventiviAccettati: "=",
        contrattiPervAttivi: "=",
        importoContrattiPervAttivi: "=",
        contrattiStipulati: "=",
        importoContrattiStipulati: "=",
        totale: "=",
        importoTotale: "="
    },
    controllerAs: "practicesGroupCtrl",
    controller: function PracticesGroup() {
        var self = this;

        self.$onInit = function () {
            self.number = 2020;
            console.log("model practicesGroup", self.model);
        };
    }
});